import React from 'react'
import AddressOptions from 'components/addressOptions'
import SelectAddress from 'components/selectAddress'

const Register = ({ hide, show, setShowRegister, signInFromBasket }) => {
    return (
        <div className={'registerform'}>
            <AddressOptions
                hide={hide}
                show={show}
                registration={true}
                setShowRegister={setShowRegister}
                signInFromBasket={signInFromBasket}
            />
            {/* <SelectAddress
                hide={hide}
                show={show}
                registration={true}
                setShowRegister={setShowRegister}
                signInFromBasket={signInFromBasket}
            /> */}
        </div>
    )
}

export default Register
